define('AwaLabs.ShowFacetsExtraValues', [
    'ShowFacetsExtraValues.Facets.FacetedNavigationItem.View'
], function ShowFacetsExtraValues(
) {
    'use strict';
});
